module.exports = __webpack_public_path__ + "static/media/15 Clay Pigeons.8e824dc5.mp3";